

export const DIVISION_NOMENCLATURE_SAMPLE_FILENAME = 'division_nomenclature_sample.xlsx';

export const DIVISION_NOMENCLATURE_MIN_LEVELS = 1;
export const DIVISION_NOMENCLATURE_MAX_LEVELS = 10;
export const DIVISION_NOMENCLATURE_LEVEL_FIELD_PREFIX = 'level_';
export const DIVISION_NOMENCLATURE_LEVEL_RADIO_GROUP = 'division-nomenclature-level';

export function formatDivisionNomenclatureBranchLevelSetMessage(levelIndex) {
  return `Level ${levelIndex} set as branch`;
}

export const DIVISION_NOMENCLATURE_BRANCH_LEVEL_CONFIG = {
  UNIQUE_ID: 'BRANCH_LEVEL',
  KEY_NAME: 'branch_level',
  CATEGORY_ID: 'BRANCH_LEVEL',
  CONFIG_CLASS: 'SYSTEM_CLASS',
};

export function getDivisionNomenclatureLevelField(levelIndex) {
  return `${DIVISION_NOMENCLATURE_LEVEL_FIELD_PREFIX}${levelIndex}`;
}

export function isDivisionNomenclatureExcelFile(file) {
  const fileName = file?.name?.toLowerCase() || '';
  return fileName.endsWith('.xlsx') || fileName.endsWith('.xls');
}
